<template>
    <div>
        <div class="col s11">
            <input  text="text" placeholder="Digite o nome da pessoa que alterou ou o nome da pessoa do dado que sofreu a atualização" 
            v-model="q" @input="getLostByDesc()"/>
            
        </div>
        <div class="col s1">
            <i class="material-icons small">search</i>
        </div>
        <base-table>
            <tr slot='head'>
                <th>Descrição</th>
            </tr>
            <tr 
            slot="body"
            v-for="(log,index) in logList"
            :key="index"
            >
                <td>{{getDescricao(log.id)}}</td>
            </tr>
        </base-table>
    </div>
</template>
<script>
    import BaseTable from './BaseTable.vue';
    import axios from 'axios';
    import moment from 'moment';
    export default {
        name:'Log',
        props:{
            logs:String
        },
        components:{
            BaseTable
        },
        data(){
            return{
               todos:JSON.parse(this.logs),
               logList:Array,
               q:""
            };
        },
        methods:{
            getLostByDesc(){
                if(this.q){
                    
                    return this.logList=this.todos.filter( t=>
                        (t.user.name.toLowerCase().includes(this.q.toLowerCase()) 
                        || JSON.parse(t.before).curriculo.usuario.name.toLowerCase().includes(this.q.toLowerCase())
                        )
                    )
                }
                else{
                    return this.logList=this.todos;
                }
            },
            getProjectUserById(log){
               return JSON.parse(log.before);
            },
            getLogById(id){
                return this.todos.find( log=>log.id == id);
            },
            getDescricao(id){
                let log=this.getLogById(id);
                if(log){
					switch (log.tabela) {
						case "projetos": {
							let before=this.getProjectUserById(log);
							 return (`
								${log.user.name} 
								${log.action == 'UPDATE' ?'atualizou': log.action == 'DELETE' ? 'excluiu' : 'inseriu'}
								a ação de ${before.curriculo.usuario.name}
								no dia ${moment(log.created_at).format("DD/MM/YYYY")}
								às ${moment(log.created_at).format('HH:mm')}						 
							 `);
							break; 						 
						}
					}
				}
			}
        },
        created(){
            this.getLostByDesc();
        }
        
    }
</script>